/*!

=========================================================
* Argon Dashboard React - v1.2.1
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import Paper from '@material-ui/core/Paper';
import React, { useRef, useState } from "react";
import { Badge, Button, Card, CardHeader, Col, Container, Row, Spinner } from "reactstrap";
import AdminUserModal from '../components/AdminUserModal';
import AdminUserScreenHeader from "../components/Headers/AdminUserScreenHeader";
import UserManagementTable from '../components/UserManagementTable';
import { useAdminAllUsers } from '../hooks/useAdminAllUsers';
import { useHistory, useLocation } from 'react-router-dom';
import { useQueryParams } from '../hooks/useQueryParams';
import { useQueryClient } from 'react-query';
import { updateQueryParams } from '../utils/updateQueryParams';
import qs from 'query-string';

const resultsPerPage = 10;

const AdminUsers: React.FC = () => {
  // const { data, isLoading } = useAllUnbilledProjects()

  // useEffect(() => {
  //   if (data?.projects) {
  //     setRows(data.projects)
  //   }
  // }, [data])

  // const {
  //   currencyFilterOperations,
  //   currencyColumns,
  //   currencyTableColumnExtensions
  // } = useCurrencyColumns(data?.currencyColumns)

  // const {
  //   dateFilterOperations,
  //   dateFilteringColumnExtensions,
  //   dateSortingColumnExtensions,
  //   dateFilterMessages
  // } = useDateColumns(data?.dateColumns)
  const query = useQueryParams()
  const location = useLocation()
  const router = useHistory()

  const [pageTable, setPageTable] = useState(1)
  const searchInputRef = useRef<HTMLInputElement | null>(null)
  const [modalOpen, setModalOpen] = useState(false)
  const [searchTerm, setSearchTerm] = useState(() => {
    const searchTerm = query.get('searchTerm')
    if (searchTerm) {
      return searchTerm
    }
    return ''
  })
  const queryClient = useQueryClient()

  const { data: userData, isLoading, error, refetch } = useAdminAllUsers(pageTable, resultsPerPage, searchTerm)

  const handleUserSearch = () => {
    if (isLoading) {
      return
    }
    queryClient.removeQueries(["adminUserList"])
    refetch()
  }

  const handlePressEnter = () => {
    setPageTable(1)
    handleUserSearch()
    const q = qs.parse(location.search)
    q.searchTerm = searchTerm
    if (searchTerm.trim().length === 0) {
      delete q.searchTerm
    }
    updateQueryParams("", router, location.pathname)
  }

  // const { mutate: initiateFollowUp, isLoading: initiateFollowUpLoading } =
  //   useInitiateFollowUpMutation(
  //     (rows) => {
  //       setRows(rows)
  //       setSelection([])
  //     },
  //     (err, msg) => {
  //       if (err) {
  //         Toastr.error(msg || 'Something went wrong. Please try again later')
  //       } else {
  //         Toastr.success('Follow ups initiated!')
  //       }
  //     })

  // const handleFollowUp = () => {
  //   if (initiateFollowUpLoading || !window.confirm('Are you sure?')) {
  //     return
  //   }
  //   initiateFollowUp(selection)
  // }

  let content: JSX.Element | null = null

  if (isLoading) {
    content = <Spinner />
  } else if (error) {
    content = <Badge type="danger" className="text-center">Something went wrong! Please try again later.</Badge>
  } else if (userData) {
    content = <div>
      <div className="mb-2">
        <Button size="sm" color="primary" onClick={() => setModalOpen(true)}>
          Add User
        </Button>
      </div>
      <UserManagementTable currentPage={pageTable} onPageChange={setPageTable} resultsPerPage={resultsPerPage} userData={userData.data} total={userData.total} />
      <AdminUserModal type='Create' open={modalOpen} onClose={() => setModalOpen(false)} />
    </div>
  }
  return (
    <>
      <AdminUserScreenHeader />
      <Container className="mt--7" fluid>
        <Row className="mt-5">
          <Col className="mb-5 mb-xl-0">
            <Card className="shadow">
              <CardHeader className="border-0">
                <Row className="align-items-center">
                  <div className="col">
                    <div className="input-group-alternative input-group">
                      <div className="input-group-prepend">
                        <span className="input-group-text">
                          <i className="fas fa-search"></i>
                        </span>
                      </div>
                      <input 
                        ref={searchInputRef} 
                        placeholder="Search user by Email" 
                        type="text" 
                        className="form-control" 
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        onKeyDown={e => {
                          if (e.key.toLowerCase() === 'enter') {
                            handlePressEnter()
                          }
                        }}
                      />
                      </div>
                  </div>
                </Row>
              </CardHeader>
              <Paper className="overflow-auto px-4 pb-4 pt-4">
                {/* <div className="mb-3">
                  <h4 style={{ display: 'inline' }}>Search Results</h4>
                </div> */}
                {content}
              </Paper>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default AdminUsers;
